import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import type { SnapshotId } from '@ipfabric/utils/snapshot';
import { generateGuid } from 'utils/guid';
import z from 'zod';
import {
  ManualDeviceLinks,
  type SettingsType,
} from '../components/ManualDeviceLinks/ManualDeviceLinks';
import type { PublicManualLink } from '../components/ManualDeviceLinks/model/ManualLinksModel';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';

export const manualDeviceLinks: FormSnippet<
  DiscoverySettingsObject,
  {
    manualLinks: PublicManualLink[];
  },
  undefined,
  {
    settingsType: SettingsType;
    snapshotId: SnapshotId | null;
  }
> = {
  render: ({ form }) => <ManualDeviceLinks form={form} />,
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.manualLinks = model.manualLinks ?? [];
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.manualLinks =
      transformedValues.manualLinks?.map((row) => ({
        ...row,
        id: row.id ?? generateGuid(),
      })) ?? [];
  },
  schema: z.object({
    manualLinks: z.any(),
  }) as z.Schema<{ manualLinks: PublicManualLink[] }>,
};
